export default __webpack_public_path__ + "static/media/LOGO.683c75a1.png";